'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bemReactCore = require('bem-react-core');

exports.default = (0, _bemReactCore.decl)({
    block: 'b-statcounter',
    elem: 'tns',
    tag: 'i',
    attrs: function attrs(_ref) {
        var id = _ref.id;

        if (!id) {
            throw new Error('b-statcounter__tns: Не передан обязательный параметр id.');
        }

        return {
            style: {
                // eslint-disable-next-line max-len
                background: 'url(//www.tns-counter.ru/V13a****yandex_ru/ru/UTF-8/tmsec=' + id + '/' + Math.floor(Math.random() * 1e9) + ')'
            }
        };
    }
});